<template>
  <div class="about padding80">
    <Header :current="1"></Header>

    <!-- <div class="banner">
      <img src="../assets/guanyu_banner01.png" />
    </div> -->

    <div class="about-us">
      <div class="all-title">
        <span class="title">公司简介</span>
        <span class="words">COMPANY PROFILE</span>
      </div>
      <div class="about-info">
        <p><b>德礼来</b>是一家以行业IT解决方案、行业IT外包服务、场景化商业运营以及平台产品研发为主营业务的科技公司。</p>
        <p>公司以诚信、敬业、务实、创新为服务宗旨，致力于为行业客户、泛金融机构提供一站式科技解决方案。公司成立以来，一直致力于生态场景的深耕和技术研发，目前主营业务为：向商业银行、企业客户以及泛金融机构提供全流程、模块化的综合金融科技解决方案，包括商业生态平台、银行IT系统建设、金融产品运营等解决方案及服务。</p>
      </div>

      <div class="about-three">
        <div class="all-title">
          <span class="title">愿景/使命/目标</span>
          <span class="words">VISION/MISSION/TARGET</span>
        </div>
        <div class="about-icons">
          <div class="item">
            <img src="../assets/guanyu_yj.png" />
            <div class="name">愿 景</div>
            <div class="txt">成为商业生态场景的最佳合作伙伴</div>
          </div>
          <div class="item">
            <img src="../assets/guanyu_mb.png" />
            <div class="name">使 命 与 目 标</div>
            <div class="txt">诚信  敬业  务实  创新</div>
          </div>
          <div class="item">
            <img src="../assets/guanyu_js.png" />
            <div class="name">技 术</div>
            <div class="txt">互联网+金融+商业+大数据+人工智能+5G+区块链</div>
          </div>
        </div>
      </div>


    </div>

    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {};
  },
  mounted() {
    // chrome 回到顶部
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
  },
  methods: {
    linkDownload(url) {
      window.open(url, "_blank"); // 新窗口打开外链接
    }
  }
};
</script>

<style scoped lang="less">
.about-us {
  padding: 50px 0 90px 0;
}
.about-info {
  margin: 0 auto;
  width: 1080px;
  p {
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 1.5;
    text-indent: 2em;
    color: #666;
  }
}
.about-three {
  margin-top: 105px;
  padding: 60px 0;
  background-color: #f9f9f7;
}
.about-icons {
  margin: 0 auto 20px auto;
  width: 1150px;
  overflow: hidden;
  .item {
    float: left;
    margin: 20px;
    padding: 1px;
    width: 340px;
    height: 360px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 4px 20px 0 rgba(33, 33, 33, 0.1);
    border-radius: 6px;
  }
  img {
    margin: 90px auto 10px auto;
    width: 70px;
    height: 70px;
  }
  .name {
    margin-bottom: 30px;
    font-size: 24px;
    color: #222;
    font-weight: 700;
  }
  .txt {
    margin: 0 35px;
    line-height: 2;
    font-size: 16px;
    color: #999;
  }
}
.about-news {
  padding: 40px 0;
}
.news-items {
  .item {
    display: block;
    margin: 24px 0 0 0;
    padding: 18px 20px;
    overflow: hidden;
    border: 1px solid #c0c0c0;
    cursor: pointer;
  }
  .img {
    float: left;
    margin-right: 18px;
    width: 208px;
    height: 146px;
  }
  .name {
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: 700;
    color: #222;
  }
  .txt {
    font-size: 16px;
    color: #666;
    line-height: 1.5;
  }
  .info {
    position: relative;
    float: left;
    height: 146px;
  }
  .more {
    position: absolute;
    left: 0;
    bottom: 5px;
    overflow: hidden;
    .label {
      float: left;
      margin-right: 25px;
      font-size: 14px;
      color: #343434;
    }
    .icon {
      display: block;
      float: left;
      margin-right: 5px;
      width: 16px;
      height: 16px;
    }
  }
}
.more-btn {
  margin: 50px auto 0 auto;
  width: 160px;
  height: 50px;
  line-height: 50px;
  color: 18px;
  text-align: center;
  color: #fff;
  background-color: #6cba46;
  border-radius: 50px;
  cursor: pointer;
}
</style>
